import { AvField, AvForm } from 'availity-reactstrap-validation'
import React from 'react'
import { Button, Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'

const AddCustomerModal = ({isOpen,toggle,onSubmit,t}) => {
  return (
   <React.Fragment>
    <Modal
            size="md"
            isOpen={isOpen}
            toggle={toggle}
          >
            <ModalHeader toggle={toggle} > {`Add New Customer`} </ModalHeader>
              <ModalBody>
                  {/* <Col lg={12}> */}

                        <AvForm onValidSubmit={onSubmit} >
                <Row>
                            <Col lg={6} md={6}>
                              <AvField
                                label={t("Name")}
                                className="form-control"
                                type="text"
                                name="name"
                                placeholder="Enter Name"
                                validate={{ required: { value: true } }}
                                errorMessage={t("Name cannot be empty")}
                              />
                            </Col>

                            <Col lg={6} md={6}>
                              <AvField
                                label={t("Mobile")}
                                className="form-control"
                                type="number"
                                name="mobile"
                                placeholder="Enter Phone Number"
                                validate={{
                                  required: { value: true },
                                  maxLength: {
                                    value: 13,
                                    errorMessage: t(
                                      "Maximum 13 characters allowed."
                                    ),
                                  },
                                }}
                                errorMessage={t(
                                  "Phone number cannot be empty"
                                )}
                              />
                            </Col>

                            <Col lg={6}>
                              <AvField
                                label={t("Customer Type")}
                                className="form-control"
                                type="select"
                                name="customer_type"
                                defaultValue="Regular"
                                placeholder="Select Customer Type"
                                // validate={{ required: { value: true } }}
                                // errorMessage={t("Customer Type cannot be empty")}
                              >
                                <option value="">
                                  {t("--Select Type--")}
                                </option>
                                <option value="Regular">
                                  {t("Regular")}
                                </option>
                                <option value="Friend">
                                  {t("Friend")}
                                </option>
                                <option value="VIP">{t("VIP")}</option>
                              </AvField>
                            </Col>
                          <hr />
                          <Col lg={12} md={12} className='text-center'>
                            <Button
                              type="submit"
                              style={{
                                position: "relative",
                                overflow: "hidden",
                                backgroundColor: "#fdd005",
                                border: "none",
                                color: "black",
                                fontSize: "15px",
                                fontWeight: "500",
                                width: "150px",

                                margin: "auto",
                                boxShadow:
                                  "rgba(255, 255, 255, .2) 0 3px 15px inset, rgba(0, 0, 0, .4) 0 3px 5px, rgba(0, 0, 0, .1) 0 10px 13px",
                                transition: "transform 0.3s ease",
                              }}
                              onMouseEnter={e => {
                                e.target.style.transform = "scale(1.05)"
                              }}
                              onMouseLeave={e => {
                                e.target.style.transform = "scale(1)"
                              }}
                            >
                              {t("Add Customer")}
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0",
                                  left: "0",
                                  right: "0",
                                  bottom: "0",
                                  background:
                                    "linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0))",
                                  pointerEvents: "none",
                                }}
                              ></div>
                            </Button>
                          </Col>
                </Row>
                        </AvForm>
                  {/* </Col> */}
              </ModalBody>
          </Modal>
   </React.Fragment>
  )
}

export default AddCustomerModal
